/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2025-11-17 15:03:26
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2025-11-17 15:04:31
 * @FilePath: /hippo-app-h5/src/router/modules/tool.ts
 * @Description:
 *
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/tool/testcache',
		name: 'testcache',
		meta: {
			title: 'testcache',
			isApp: true,
			auth: false,
		},
		component: () => import('@/views/tool/testcache.vue'),
	},
]

export default routes
